<div id="sustainability-dashboard-empty-contracts">
  <div class="content">
    @if (wasThereError()) {
      <i class="ph-fill ph-info error-icon"></i>
      <span class="title">{{ 'doktar_app.common_errors.someting_went_wrong_title' | translate }}</span>
      <span class="description mb-3">
        {{ 'doktar_app.services.crop_monitoring.irrigation_program.preparing_error_description' | translate }}
      </span>
      <dk-button [label]="'doktar_app.common.try_again_button' | translate" (onClick)="tryAgainEvent.emit()" />
    } @else {
      <i class="ph-fill ph-stack-minus icon"></i>
      <span class="title">{{ 'doktar_app.account.enterprise.contract.no_contract_title' | translate }}</span>
      <span class="description mb-3">
        {{ 'doktar_app.account.enterprise.contract.no_contract_description' | translate }}
      </span>
    }
  </div>
</div>
